import React, { Component } from 'react';
import PropTypes from "prop-types";
import logger from '../../logging/logger';

class CustomSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultSelectText: "",
      showOptionList: false,
      optionsList: [],
      value: props.value || (props.multiple ? [] : "")
    };
  }

  componentDidMount() {
    // Add Event Listner to handle the click that happens outside
    // the Custom Select Container
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    // Update the internal state if the value prop changes
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  componentWillUnmount() {
    // Remove the event listner on component unmounting
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  // This method handles the click that happens outside the
  // select text and list area
  handleClickOutside = e => {
    if (
      !e.target.classList.contains("custom-select-option") &&
      !e.target.classList.contains("selected-text")
    ) {
      this.setState({
        showOptionList: false
      });
    }
  };

  // This method handles the display of option list
  handleListDisplay = () => {
    this.setState(prevState => {
      return {
        showOptionList: !prevState.showOptionList
      };
    });
  };

  // This method handles the setting of name in select text area
  // and list display on selection
  handleOptionClick = e => {
    if (this.props.multiple) {
      // For multi-select, update the internal state
      const selectedId = e.target.getAttribute("data-query");
      const newValues = [...this.state.value];
      const index = newValues.indexOf(selectedId);
      
      if (index === -1) {
        // Hinzufügen, wenn nicht bereits ausgewählt
        newValues.push(selectedId);
      } else {
        // Entfernen, wenn bereits ausgewählt
        newValues.splice(index, 1);
      }
      
      this.setState({ value: newValues });
      this.props.onChange(e.target);
    } else {
      // For single-select, set the text and close the list
      this.setState({
        defaultSelectText: e.target.getAttribute("data-name"),
        showOptionList: false
      });

      this.props.onChange(e.target);
    }
  };

  render() {
    const { optionsList, selectLabel, arrowIconClass, border, value, multiple, placeholder } = this.props;
    const { showOptionList } = this.state;

    let displayText = "";
    if (multiple) {
      // For multi-select, show selected items or placeholder
      if (Array.isArray(this.state.value) && this.state.value.length > 0) {
        // Prüfen, ob "Top 5" ausgewählt ist
        if (this.state.value.includes('top5')) {
          displayText = "Top 5";
        } else {
          // Für andere ausgewählte Werte "..." anzeigen
          displayText = "...";
        }
      } else {
        displayText = placeholder || "Bitte auswählen";
      }
    } else {
      // For single-select, show selected item or default text
      const selectedOption = optionsList.find(opt => opt.id == this.state.value);
      displayText = selectedOption ? selectedOption.name : (this.state.defaultSelectText || optionsList?.[0]?.name || '');
    }

    return (
      <div className="custom-select-container">
        <div className='custom-select-text-wrapper'>
          { selectLabel ? 
              <span className="selectLabel txt-caps-small-regular">{selectLabel}</span>
            : ''
          }
          <div
            className={`
              ${showOptionList ? "selected-text active" : "selected-text"} 
              ${arrowIconClass ? 'arrowIcon' : '' }
              ${border ? 'border': ''}
            `}
            onClick={this.handleListDisplay}
          >
            {displayText}
            {arrowIconClass ? <i className={arrowIconClass}></i> : '' }
          </div>
        </div>
        {showOptionList && (
          <ul className="select-options">
            {optionsList.map((option, index) => {
              // Prüfen, ob es sich um den "Top 5" Eintrag handelt
              if (option.id === 'top5') {
                return (
                  <li
                    className="custom-select-option top5-option"
                    data-name={option.name}
                    data-query={option.id}
                    key={option.id}
                    onClick={this.handleOptionClick}
                  >
                    {option.name}
                    <hr className="divider" />
                  </li>
                );
              }
              
              // Prüfen, ob der Eintrag ausgewählt ist
              const isSelected = multiple && Array.isArray(this.state.value) && this.state.value.includes(option.id);
              
              // Prüfen, ob die maximale Anzahl an ausgewählten Elementen erreicht ist
              // Erlaube das Abwählen auch wenn das Limit erreicht ist
              const isDisabled = multiple && Array.isArray(this.state.value) && this.state.value.length >= 5 && !isSelected && option.id !== 'top5';
              
              return (
                <li
                  className={`custom-select-option ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                  data-name={option.name}
                  data-query={option.id}
                  key={option.id}
                  onClick={(e) => {
                    // Verhindern, dass deaktivierte Elemente ausgewählt werden
                    // Erlaube das Abwählen auch wenn das Limit erreicht ist
                    if (!isDisabled || isSelected) {
                      this.handleOptionClick(e);
                    }
                  }}
                >
                  {multiple && (
                    <input
                      type="checkbox"
                      checked={isSelected}
                      readOnly
                      style={{ pointerEvents: 'none' }}
                    />
                  )}
                  {option.name}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  }
}

export default CustomSelect;

CustomSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  optionsList: PropTypes.array.isRequired,
  selectLabel: PropTypes.string,
  arrowIconClass: PropTypes.string,
  border: PropTypes.bool,
  defaultText: PropTypes.string,
  value: PropTypes.any,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string
}

CustomSelect.defaultProps = {
  border: false,
  defaultText: "Text",
  multiple: false
}
